import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { alpha } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';

import { ScreenSize } from '../../../@types';

const SIDEBAR_WIDTH = 220;

export const AppShellSkeleton: React.FC = () => {
  const isMobile = useMediaQuery(ScreenSize.MOBILE);

  return (
    <Box sx={{ display: 'flex', height: '100vh', bgcolor: 'v4.background' }}>
      {/* Sidebar placeholder */}
      {!isMobile && (
        <Box
          sx={{
            width: SIDEBAR_WIDTH,
            flexShrink: 0,
            bgcolor: 'v4.sidebar',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            pt: 3,
            px: 2,
          }}
        >
          <Skeleton variant="rectangular" width={140} height={40} sx={(theme) => ({ bgcolor: alpha(theme.palette.common.white, 0.08), borderRadius: theme.shape.borderRadius / 4 })} />
          {[1, 2, 3, 4, 5].map((i) => (
            <Skeleton key={i} variant="rectangular" height={20} sx={(theme) => ({ bgcolor: alpha(theme.palette.common.white, 0.06), borderRadius: theme.shape.borderRadius / 8 })} />
          ))}
        </Box>
      )}

      {/* Content area */}
      <Box sx={{ flex: 1, p: 2.5, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {/* Title row */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Skeleton variant="rectangular" width={280} height={28} sx={{ borderRadius: 0.5 }} />
          <Skeleton variant="rectangular" width={180} height={24} sx={{ borderRadius: 0.5 }} />
        </Box>

        {/* Table skeleton */}
        <Skeleton variant="rectangular" width="100%" height={48} sx={{ borderRadius: 0.5 }} />
        {[1, 2, 3, 4, 5].map((i) => (
          <Skeleton key={i} variant="rectangular" width="100%" height={36} sx={{ borderRadius: 0.5, opacity: 1 - i * 0.1 }} />
        ))}

        {/* Timestamp */}
        <Skeleton variant="rectangular" width={220} height={14} sx={{ borderRadius: 0.5, alignSelf: 'flex-end' }} />
      </Box>
    </Box>
  );
};
